import { i18WithDefault as t } from '@shared/locales'
import { Auth } from 'aws-amplify'
import { useFormik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { EnterEmailForm } from './enter_email_form'
import { VerifyEmailForm } from './verify_email_form'

export type TFormikValues = {
  email: string
  inputCode: boolean
  code: string
}

export type ChallengeResponseType = {
  username: string
  answer: string
}

type SignInTooltipContentProps = {
  onError?: (error: Error) => void
  onSuccessfulSignIn?: () => void
}

export const SignInTooltipContent = ({ onError, onSuccessfulSignIn }: SignInTooltipContentProps) => {
  const [showVerifyForm, setShowVerifyForm] = React.useState(false)
  const [cognitoUser, setCognitoUser] = React.useState(null)

  const formik = useFormik<TFormikValues>({
    initialValues: {
      email: '',
      inputCode: false,
      code: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email(t('global.label.invalidEmail')).required(t('global.label.required')),
      inputCode: Yup.boolean(),
      code: Yup.string().when('inputCode', {
        is: true,
        then: Yup.string().length(6, t('global.label.invalidCode')).required(t('global.label.required')),
      }),
    }),
    onSubmit: ({ email, code }, { setSubmitting }) => {
      if (email) {
        if (!code) {
          Auth.signIn(email.toLowerCase().trim())
            .then((result) => {
              setCognitoUser(result)
              setShowVerifyForm(true)
              formik.setFieldValue('inputCode', true)
              formik.setTouched({ code: false })
            })
            .catch((error) => {
              formik.setErrors({ email: t('global.sendCodeError') })
              onError?.(error)
            })
            .finally(() => setSubmitting(false))
        } else if (cognitoUser) {
          Auth.sendCustomChallengeAnswer(cognitoUser, code)
            .then((result) => {
              if (!result.signInUserSession) {
                formik.setFieldError('code', t('global.label.wrongCode'))
              } else {
                onSuccessfulSignIn?.()
              }
            })
            .catch((error) => {
              console.log(error)
              formik.setFieldError('code', t('global.verifyCodeError'))
              onError?.(error)
            })
            .finally(() => setSubmitting(false))
        }
      }
    },
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {showVerifyForm ? (
          <VerifyEmailForm formik={formik} setShowVerifyForm={setShowVerifyForm} setCognitoUser={setCognitoUser} />
        ) : (
          <EnterEmailForm formik={formik} />
        )}
      </form>
    </>
  )
}

export default SignInTooltipContent
